import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { FontAwesome } from '@expo/vector-icons';
import Style from '../../../../constants/Style';
import Colors from '../../../../constants/Colors';
import PressableStyled from '../../../PressableStyled';

interface GraphDateLabelProps {
  label: string,
  back: () => void,
}

const GraphDateLabel = ({ label, back }: GraphDateLabelProps) => <View
  style={[Style.row, styles.container]}
>
  <PressableStyled onPress={back}>
    <FontAwesome
      name='angle-left'
      size={16}
      color={Colors.light.hereworksBlue500}
    />
  </PressableStyled>
  <Text style={styles.text}>{label}</Text>
</View>;

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue100,
    backgroundColor: Colors.light.hereworksWhite200,
    borderRadius: 8,
    paddingHorizontal: 4,
    marginBottom: 16,
    alignSelf: 'flex-start',
  },
  text: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack400,
    marginStart: 8,
  },
});

export default GraphDateLabel;
